import { createAction } from '@reduxjs/toolkit';

export const proposeThemeAction = createAction<{ theme: string, benefit: string }>('PROPOSE_THEME');
